import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="formular"
export default class extends Controller {
	static targets = ["submitButton", "cancelButton", "wiederholend", "datumLabel", "sliderDiv"]

	static values = {
		spinnerSVG:
			'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="width: 1.5rem; height: 100%; background: none;"><circle cx="50" cy="50" fill="none" ng-attr-stroke="{{config.color}}" ng-attr-stroke-width="{{config.width}}" ng-attr-r="{{config.radius}}" ng-attr-stroke-dasharray="{{config.dasharray}}" stroke="#ffffff" stroke-width="4" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(335.771 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>',
	}

	connect() {}

	submitStart() {
		// Submit-Button disabelen
		if (this.hasCancelButtonTarget) this.cancelButtonTarget.disabled = true
		this.submitButtonTarget.disabled = true
		// Spinner sichtbar machen
		this.submitButtonTarget.innerHTML = this.spinnerSVGValue
	}

	formatValue({ currentTarget, params }) {
		const nks = params.nks || 0
		const nks_max = params.nksmax || nks
		const rechnen = params.rechnen || false

		const floatBetrag = rechnen ? rechenoperation(currentTarget, nks_max) : this.elementValueToFloat(currentTarget)

		currentTarget.value = new Intl.NumberFormat("de-DE", { minimumFractionDigits: nks, maximumFractionDigits: nks_max }).format(floatBetrag)

		// Input Event triggern (z.b. wichtig für Beitragsübersicht)
		currentTarget.dispatchEvent(new Event("input", { bubbles: true, cancelable: true }))
	}

	updateBuchungsintervall({ currentTarget }) {
		if (currentTarget.value == 0 || currentTarget.value == "einmalig") {
			this.showEinmalig()
		} else {
			this.showWiederholend()
		}
	}

	sliderOnOff({ currentTarget }) {
		// Wenn das CurrentTarget eine Checkbox ist (SonstigerVermoegenswert)
		if (currentTarget.type === "checkbox") {
			if (currentTarget.checked) {
				// Slider wird angezeigt
				this.sliderDivTarget.classList.remove("invisible")
			} else {
				// Slider wird nicht angeziegt
				this.sliderDivTarget.classList.add("invisible")
			}
		} else {
			// Wenn das CurrentTarget eine Selectbox ist (Immobilie)
			if (currentTarget.value == 1) {
				// Teil-Slider wird angezeigt
				this.sliderDivTarget.classList.remove("invisible")
			} else {
				// Teil-Slider wird nicht angeziegt
				this.sliderDivTarget.classList.add("invisible")
			}
		}
	}

	// Private Methods

	elementValueToFloat(element) {
		return parseFloat(element.value.replace(/\./g, "").replace(",", "."))
	}

	showEinmalig() {
		this.wiederholendTargets.forEach((element) => element.classList.add("hidden"))
		if (this.hasDatumLabelTarget) this.datumLabelTarget.innerHTML = "Im"
	}

	showWiederholend() {
		this.wiederholendTargets.forEach((element) => element.classList.remove("hidden"))
		if (this.hasDatumLabelTarget) this.datumLabelTarget.innerHTML = "Beginn"
	}
}
